/** Lista `ListaStakeManager` (slisBNB) withdrawal read surface.
 *
 *  - `getUserWithdrawalRequests(user)` → the user's open requests
 *    (`uuid`, `amountInSnBnb` = slisBNB burned, `startTime`).
 *  - `getUserRequestStatus(user, idx)` → `(isClaimable, amount)` where
 *    `amount` is the BNB owed and `idx` indexes the array above. */
export const ListaWithdrawalAbi = [
  {
    name: 'getUserWithdrawalRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'user' }],
    outputs: [
      {
        type: 'tuple[]',
        components: [
          { type: 'uint256', name: 'uuid' },
          { type: 'uint256', name: 'amountInSnBnb' },
          { type: 'uint256', name: 'startTime' },
        ],
      },
    ],
  },
  {
    name: 'getUserRequestStatus',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'user' },
      { type: 'uint256', name: 'idx' },
    ],
    outputs: [
      { type: 'bool', name: '_isClaimable' },
      { type: 'uint256', name: '_amount' },
    ],
  },
] as const
